export const GRAPHQL = {
    Endpoint: import.meta.env.VITE_GRAPHQL_ENDPOINT,
};
